import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTierService } from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import { Betriebskontakt } from '../../../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

export interface DashboardTierlisteHerkunftSetzenDialogData {
    tierliste_id: number;
}

@Component({
    selector: 'kiene-dashboard-tierliste-herkunft-setzen-dialog',
    templateUrl: './dashboard-tierliste-herkunft-setzen-dialog.component.html',
    styleUrls: ['./dashboard-tierliste-herkunft-setzen-dialog.component.scss'],
})
export class DashboardTierlisteHerkunftSetzenDialogComponent {
    selectedKontakt: Betriebskontakt | null = null;
    isSaving = false;
    removeHerkunft = false;

    constructor(
        private readonly dialogRef: MatDialogRef<DashboardTierlisteHerkunftSetzenDialogComponent, string | false>,
        @Inject(MAT_DIALOG_DATA) public data: DashboardTierlisteHerkunftSetzenDialogData,
        private readonly gruppeTierService: GruppeTierService,
        private readonly messageService: MessageService,
    ) {}

    onKontaktSelected(kontakt: Betriebskontakt): void {
        this.selectedKontakt = kontakt;
        this.removeHerkunft = false;
    }

    onKontakteSelected(kontakte: Betriebskontakt[]): void {
        if (kontakte?.length > 0) {
            this.onKontaktSelected(kontakte[0]);
        }
    }

    clearSelection(): void {
        this.selectedKontakt = null;
        this.removeHerkunft = true;
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    save(): void {
        if (!this.data?.tierliste_id) {
            this.messageService.errorMessage('Keine Tierliste ausgewählt!', null);
            return;
        }

        if (!this.selectedKontakt && !this.removeHerkunft) {
            this.messageService.errorMessage('Bitte wählen Sie einen Herkunftsbetrieb aus oder entfernen Sie ihn.', null);
            return;
        }

        this.isSaving = true;
        this.gruppeTierService
            .updateTierlisteHerkunftOnly(this.data.tierliste_id, this.removeHerkunft ? null : this.selectedKontakt)
            .subscribe({
                next: success => {
                    this.isSaving = false;
                    if (!success) {
                        this.dialogRef.close(false);
                        return;
                    }

                    const message = this.removeHerkunft
                        ? 'Herkunftsbetrieb erfolgreich entfernt.'
                        : 'Herkunftsbetrieb für die Tierliste gesetzt.';
                    this.messageService.infoMessage(message);
                    const label = this.removeHerkunft
                        ? ''
                        : (this.selectedKontakt?.bezeichnung_final || this.selectedKontakt?.bezeichnung || '').trim();
                    this.dialogRef.close(label);
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Herkunftsbetrieb konnte nicht aktualisiert werden!', err);
                },
            });
    }
}
